export default {"src":"/_next/static/media/bookmark_unfilled.fb8a7818.svg","height":24,"width":18,"blurWidth":0,"blurHeight":0};